/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Crosspostingoverviewemptyhint3Inputs */

const en_crosspostingoverviewemptyhint3 = /** @type {(inputs: Crosspostingoverviewemptyhint3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Once you publish a post for this place, it will appear here.`)
};

const de_crosspostingoverviewemptyhint3 = /** @type {(inputs: Crosspostingoverviewemptyhint3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sobald du einen Beitrag für diesen Ort veröffentlichst, erscheint er hier.`)
};

/**
* | output |
* | --- |
* | "Once you publish a post for this place, it will appear here." |
*
* @param {Crosspostingoverviewemptyhint3Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const crosspostingoverviewemptyhint3 = /** @type {((inputs?: Crosspostingoverviewemptyhint3Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Crosspostingoverviewemptyhint3Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_crosspostingoverviewemptyhint3(inputs)
	return de_crosspostingoverviewemptyhint3(inputs)
});
export { crosspostingoverviewemptyhint3 as "crosspostingOverviewEmptyHint" }